const testimonials = [
  {
    name: 'Marco R.',
    handle: '@marcorossi',
    text: 'Finalmente una guida chiara in italiano su Itaobuy Spreadsheet. Ho trovato prodotti che cercavo da settimane in pochi minuti. Davvero utile per chi e alle prime armi come me.',
  },
  {
    name: 'Chiara B.',
    handle: '@chiarabianchi',
    text: 'Avevo sempre paura di acquistare online senza sapere cosa aspettarmi. Questa guida mi ha dato la sicurezza che cercavo. La sezione sulla sicurezza e indispensabile.',
  },
  {
    name: 'Luca D.',
    handle: '@lucadonati',
    text: 'Utilizzo Itaobuy Spreadsheet da qualche mese e non potrei farne a meno. Il confronto prodotti e velocissimo e le categorie sono organizzate in modo impeccabile.',
  },
  {
    name: 'Sofia M.',
    handle: '@sofiamoretti',
    text: 'La migliore risorsa italiana per chi vuole orientarsi nel mondo degli acquisti online. Consigli pratici, guide dettagliate e un sacco di informazioni utili. La consiglio a tutti!',
  },
  {
    name: 'Andrea F.',
    handle: '@andreaferrari',
    text: 'Da principiante assoluto, questa guida mi ha aperto un mondo. Non avrei mai pensato che organizzare la ricerca prodotti potesse essere cosi semplice ed efficace.',
  },
  {
    name: 'Giulia P.',
    handle: '@giuliaparisi',
    text: 'Itaobuy Spreadsheet ha cambiato il mio modo di fare shopping online. La qualita delle informazioni e dei prodotti che ho trovato e nettamente superiore rispetto alle mie ricerche precedenti.',
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100/70">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide uppercase mb-4">
            Cosa Dicono
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 max-w-xl">
            La comunita italiana condivide la sua esperienza
          </h2>
        </div>

        <div className="columns-1 md:columns-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="break-inside-avoid mb-6 bg-white rounded-xl p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-accent-700 font-semibold text-sm">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-foreground-900 font-semibold text-sm">{t.name}</div>
                  <div className="text-foreground-400 text-xs">{t.handle}</div>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}